import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';

// position table data
export const ResponseData = [
    {
        id: 1,
        logo: 'FK',
        company: 'Flipkoins',
        position: 10,
        position_type: 'Full-Time',
        application_count: 4,
        location: 'Bengaluru',
        status: 'Active',
    },
    {
        id: 2,
        logo: 'FK',
        company: 'Flipkoins',
        position: 10,
        position_type: 'Full-Time',
        application_count: 4,
        location: 'Bengaluru',
        status: 'Active',
    },
    {
        id: 3,
        logo: 'FK',
        company: 'Flipkoins',
        position: 10,
        position_type: 'Full-Time',
        application_count: 4,
        location: 'Bengaluru',
        status: 'Active',
    },
    {
        id: 4,
        logo: 'FK',
        company: 'Flipkoins',
        position: 10,
        position_type: 'Full-Time',
        application_count: 4,
        location: 'Bengaluru',
        status: 'Active',
    },
];

// Positions table header
export const PositionHead = [
    {label: 'id', key: 'id', hide: true, type: 'text', headClass: 'w-80', bodyClass: ''},
    {label: 'Avatar', key: 'logo', hide: false, type:'text', headClass: 'w-80', bodyClass: 'avatar-pic' },
    {label: 'Company Name', key: 'company', hide: false, type: 'text', headClass: 'w-150', bodyClass: '' },
    {label: 'Position', key: 'position', hide: false, type: 'text', headClass: 'w-150', bodyClass: '' },
    {label: 'Position Type',key: 'position_type', hide: false, type: 'text', headClass: 'w-150', bodyClass: 'badge-outlined badge-success' },
    {label: 'Application Count', key: 'application_count', hide: false, type: 'text', headClass: 'w-200', bodyClass: '' },
    {label: 'Location', key: 'location', hide: false, type: 'text', headClass: 'w-150' },
    {label: 'Status', key: 'status', hide: false, type: 'text', headClass: 'w-150', bodyClass: 'badge-outlined badge-warning' },
    {label: 'Action', key: 'actions', hide: false, type: 'actions', headClass: 'w-150 action-head',
        actions: [
            { bodyClass: 'icon-success', type: 'edit', icon: EditIcon, text: 'Edit', url: '', actionClass: 'icon-wrapper' },
            { bodyClass: 'icon-warning', type: 'open', icon: GetAppIcon, text: 'Open JD', url: '', actionClass: 'icon-wrapper' },
            { bodyClass: 'icon-danger', type: 'delete', icon: DeleteIcon, text: 'Delete', url: '', actionClass: 'icon-wrapper' }
        ]
    },
];

// page header, title, breadcrumb and button
export const PageHeader = {
    className: 'page-header',
    page_title: "Positions",
    button: { text: 'Create Position', hide: false, className: 'link-button btn-sm btn-primary', url: '/positions/create'},
    breadcrumb: [
           { text: "Dashboard", link: "/dashboard", className: "" },
           { text: "Positions", link : "", className: "active" }
    ]
};

// Filter data
export const MainFilter = {
    filterClass:'',
    list: [
        { label: 'Search', placeholder: 'Search', variant:"outlined", formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', margin:"dense", hide: false, type:'text' },
        { label: 'Position type', placeholder: 'Position type', formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', variant:"outlined", margin:"dense", hide: false, type:'multiselect' },
        { label: 'Company Name', placeholder: 'Company', variant:"outlined", formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', margin:"dense", hide: false, type:'text' },
        { label: 'Position', placeholder: 'Position', variant:"outlined", formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', margin:"dense", hide: false, type:'text' },
        { label: 'Salary', placeholder: 'Min', xs:12, sm:12, md:3, lg:1, xl:1, formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', variant:"outlined", margin:"dense", hide: false, type:'text' },
        { label: '', placeholder: 'Max', xs:12, sm:12, md:3, lg:1, xl:1, formControlClass:'filter-formControl', fieldClass: 'textBoxStyle', labelClass:'filter-label-min', variant:"outlined", margin:"dense", hide: false, type:'text' },
    ]
}

// Position Data
export const PositionData = [
    { label: 'Full Time', key: 'full_time', value: 'Full Time' },
    { label: 'Part Time', key: 'part_time', value: 'Part Time' },
    { label: 'Freelance', key: 'freelance', value: 'Freelance' }
];

// Tabs data
// export const Tabs = {
//     tabClass: 'dashboard-tab',
//     list: [
//         {label: 'Create Position', link: '/positions/create', className: 'tab-link',},
//         {label: 'Positions', link: '/positions',  className: 'tab-link', }
//     ]
// }

// Tabs data
export const Tabs = {
    tabClass: 'dashboard-tab',
    list: [
      { label: 'Create Position', key: 'create', link: '/positions/create', className: 'tab-link' },
      {
        label: 'Edit Position',
        key: 'edit',
        link: '/positions/edit/:id',
        path: '/positions/edit/:id',
        className: 'tab-link',
      },
      {
        label: 'View Position',
        key: 'view',
        link: '/positions/view/:id',
        path: '/positions/view/:id',
        className: 'tab-link',
      },
      { label: 'Positions', key: 'positions', link: '/positions', className: 'tab-link' },
    ],
  };
  